import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import {
  listReservations,
  getReservation,
  getReservationByEmailReservationNumber
} from './api';
import {
  LIST_RESERVATIONS_REQUEST,
  GET_RESERVATION_REQUEST,
  GET_RESERVATION_BY_EMAIL_RESERVATIONNUMBER_REQUEST,
  GET_RESERVATION_SUCCESS,
  RESERVATION_REQUESTING,
  LIST_RESERVATIONS_SUCCESS,
  RESET_RESERVATION_ISFETCHING
} from './constants';

export function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_REQUESTING });
    const response = yield call(
      listReservations,
      customerId(),
      action.queryString
    );
    yield put({
      type: LIST_RESERVATIONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_RESERVATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_REQUESTING });
    const response = yield call(
      getReservation,
      customerId(),
      action.reservationId
    );
    yield put({
      type: GET_RESERVATION_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_RESERVATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* getByEmailReservationNumber(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_REQUESTING });
    const response = yield call(
      getReservationByEmailReservationNumber,
      action.email,
      action.reservationNumber
    );
    yield put({ type: GET_RESERVATION_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_RESERVATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(LIST_RESERVATIONS_REQUEST, list);
  yield takeLatest(GET_RESERVATION_REQUEST, get);
  yield takeLatest(
    GET_RESERVATION_BY_EMAIL_RESERVATIONNUMBER_REQUEST,
    getByEmailReservationNumber
  );
}

export default function* reservationSagas() {
  yield all([watchList()]);
}

const customerId = () => jwtDecode(Cookies.get('customerToken')).sub;
